import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const fields = [
  ['business_name', 'Бизнесийн нэр', 'text', 'organization', 120],
  ['owner_name', 'Эзэмшигчийн нэр', 'text', 'name', 100],
  ['email', 'Email', 'email', 'email', 254],
  ['phone', 'Утасны дугаар', 'tel', 'tel', 30],
  ['password', 'Нууц үг', 'password', 'new-password', 72],
];

export const SignupForm = ({ values, setValues, busy, onSubmit }) => (
  <form data-testid="signup-form" onSubmit={onSubmit} className="signup-fields">
    {fields.map(([name, label, type, autoComplete, maxLength]) => (
      <div key={name} className={name === 'business_name' || name === 'password' ? 'signup-wide' : ''}>
        <Label data-testid={`signup-${name.replaceAll('_', '-')}-label`} htmlFor={`signup-${name}`}>{label}</Label>
        <Input id={`signup-${name}`} data-testid={`signup-${name.replaceAll('_', '-')}-input`}
          type={type} autoComplete={autoComplete} required maxLength={maxLength}
          minLength={name === 'password' ? 8 : name === 'phone' ? 3 : 1}
          value={values[name]} disabled={busy}
          onChange={event => setValues({ ...values, [name]: event.target.value })} />
      </div>
    ))}
    <div className="signup-wide signup-type">
      <Label data-testid="signup-business-type-label" htmlFor="signup-business-type">Үйл ажиллагааны төрөл</Label>
      <select id="signup-business-type" data-testid="signup-business-type-select" disabled={busy}
        value={values.business_type} onChange={event => setValues({ ...values, business_type: event.target.value })}>
        <option data-testid="signup-type-cafe-option" value="cafe">Кафе</option>
        <option data-testid="signup-type-restaurant-option" value="restaurant">Ресторан</option>
        <option data-testid="signup-type-billiard-option" value="billiard">Билльярд</option>
        <option data-testid="signup-type-other-option" value="other">Бусад</option>
      </select>
    </div>
    <div className="signup-wide">
      <Label data-testid="signup-invite-code-label" htmlFor="signup-invite_code">Урилгын эсвэл урамшууллын код (заавал биш)</Label>
      <Input id="signup-invite_code" data-testid="signup-invite-code-input" type="text" autoComplete="off" maxLength={32}
        value={values.invite_code || ''} disabled={busy} placeholder="Жишээ: K7P2QX"
        onChange={event => setValues({ ...values, invite_code: event.target.value.toUpperCase() })} />
      <p className="signup-hint">Найзын урилгын кодоор туршилт 60 хоног болно.</p>
    </div>
    <Button type="submit" data-testid="signup-start-button" disabled={busy} className="signup-primary signup-wide">
      {busy ? 'Илгээж байна…' : 'Бүртгүүлэх'}<ArrowRight size={18} aria-hidden="true" />
    </Button>
  </form>
);